/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 20.12.12, 18:01
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { IBasicGGSTextField } from "../IBasicGGSTextField";
import { GGSTextFieldSignal } from "./GGSTextFieldSignal";

import MouseEvent = createjs.MouseEvent;

export class ClickSignal extends GGSTextFieldSignal {
    constructor() {
        super();
        this.mappedEventType = MouseEvent.CLICK;
    }

    public dispatchTyped(basicTextField: IBasicGGSTextField): void {
        super.dispatch(basicTextField);
    }
}
